<template>
  <!-- Contact type selector -->
  <div class="center" v-if="userRole !== 22 && userRole !== 25">
    <!-- All -->
    <label class="container-radio" @click.prevent="updateShow('all')">
      <span class="checkmark" :class="{ checked: show === 'all' }"></span>All
    </label>

    <!-- Client -->
    <label class="container-radio" @click.prevent="updateShow('client')">
      <span class="checkmark" :class="{ checked: show === 'client' }"></span
      >Client
    </label>

    <!-- Person -->
    <label class="container-radio" @click.prevent="updateShow('person')">
      <span class="checkmark" :class="{ checked: show === 'person' }"></span
      >Person
    </label>

    <!-- Group -->
    <label class="container-radio" @click.prevent="updateShow('group')">
      <span class="checkmark" :class="{ checked: show === 'group' }"></span
      >Group
    </label>

    <!-- Users -->
    <label class="container-radio" @click.prevent="updateShow('user')">
      <span class="checkmark" :class="{ checked: show === 'user' }"></span>User
    </label>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "ChatHeaderList",
  props: {
    show: String, // Show which inner
    updateShow: Function // Update which inner to show
  },
  computed: {
    ...mapGetters({
      userRole: "getUserRole"
    })
  }
};
</script>

<style scoped>
div.center {
  display: flex !important;
  margin: 10px 0 !important;
  justify-content: space-around !important;
  flex-wrap: no-wrap;
  padding:0 10px;
}

.container-radio {
  padding-right: 0px !important;
  padding-left: 18px;
}
</style>
